function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm4.5 13l-5.2 3.8c-.2.2-.5.2-.7.2-.2 0-.4 0-.5-.1-.4-.2-.7-.6-.7-1.1V8.2c0-.5.3-.9.7-1.1.4-.2.9-.1 1.2.1l5.2 3.8c.3.2.5.6.5 1s-.2.8-.5 1z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;